import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import { variant_type } from "../../../utils/common";
library.add(fas);

const ProductModal = (props) => {
  const data = props?.data;

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Product Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="order_table_scroll">
            <Table striped bordered hover responsive center>
              <thead>
                <tr className="">
                  <th className="sr">Sr. No.</th>
                  <th className="tax-name">Products </th>
                  <th className="tax-name">Category </th>
                  <th className="tax-name">Variant Name </th>
                  {/* <th className="tax-name">Sub Category </th>
                <th className="tax-name">Child category</th> */}
                  <th className="tax-name">Sub Total Amount</th>
                  {/* <th className="tax-name">Packing Charges </th> */}
                  <th className="tax-name">Delivery Charges </th>
                  {/* <th className="tax-name">Refer Discount</th>
                <th className="tax-name">Offer Discount </th> */}
                  <th className="tax-name">Quantity </th>
                  <th className="tax-name">Coupon Discount </th>
                  <th className="tax-name">Total Tax </th>
                  <th className="tax-name">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data?.length > 0 &&
                  data?.map((item, index) => (
                    <tr className="" key={index}>
                      <td>{++index}</td>
                      <td>{item?.Product?.name}</td>
                      <td>{item?.Product?.p_category?.name}</td>
                      <td>
                        {item?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            <strong>Size :</strong>{" "}
                            {item?.Product_Variant?.Metal?.name}{" "}
                          </>
                        )}

                        {item?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            <strong>Size :</strong>{" "}
                            {item?.Double_Variant?.Product_Variant?.Metal?.name}
                            , <strong>Size:</strong>{" "}
                            {item?.Double_Variant?.Size?.name}
                          </>
                        )}

                        {item?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            <strong>Size :</strong>{" "}
                            {
                              item?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            ,{"  "}
                            <strong>Size:</strong>{" "}
                            {item?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                            <strong>Diamond:</strong>{" "}
                            {item?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </td>

                      {/* <td>{item?.Product?.p_sub_category?.name}</td>
                    <td>{item?.Product?.p_child_category?.name}</td> */}

                      <td>₹ {item?.total_selling_price}</td>
                      {/* <td>{item?.packing_charges}</td> */}
                      <td>
                        ₹ {Number(item?.delivery_charges || 0).toFixed(2)}
                      </td>
                      {/* <td>{item?.refer_discount}</td>
                     <td>{item?.offer_discount}</td> */}
                      <td>{item?.quantity}</td>
                      <td>₹ {item?.coupon_discount}</td>
                      <td>₹ {Number(item?.total_tax || 0).toFixed(2)}</td>
                      <td>₹ {Number(item?.total_amount || 0).toFixed(2)}</td>

                      {/* <td>
                      {item?.Order_Add_Ons &&
                        item?.Order_Add_Ons?.map((d, i) => (
                          <div key={i}>
                            {++i}. {d?.Food_Add_On?.name}
                          </div>
                        ))}
                    </td> */}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <Link>
                <CancelButton name={"Close"} handleClose={props.handleClose} />
              </Link>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductModal;
